import { NgModule } from '@angular/core';
import { CustomMaterialModule } from '@app/core/material.module';
import { CommonModule } from '@angular/common';
import { SelectionListComponent } from '../component/selection-list.component';
import { InputSearchModule } from '@components/input-search/input-search.module';
import { PanelTitleModule } from '@components/panel-title/panel-title.module';
import { SkeletonDirectiveModule } from '../../../directives/skeleton/skeleton-directive.module';
import { GlobalModule } from '@app/core/global.module';
import { HighlightModule } from '../../../directives/highlight/highlight.module';
import { CustomScrollDirective } from '@directives/custom-scroll/custom-scroll.directive';
import { FuiButtonComponent, FuiCheckboxComponent, FuiIconComponent } from '@fui/fui-components';

@NgModule({
    declarations: [SelectionListComponent],
    exports: [SelectionListComponent],
    imports: [
        CommonModule,
        InputSearchModule,
        PanelTitleModule,
        SkeletonDirectiveModule,
        CustomMaterialModule,
        GlobalModule,
        HighlightModule,
        CustomScrollDirective,
        FuiButtonComponent,
        FuiCheckboxComponent,
        FuiIconComponent,
    ],
})
export class SelectionListModule {}
